export default "__VITE_ASSET__2ec259cb__"